<template>
  <div class="comReport">
    <div v-if="$store.state.common.theme==3" class="topTab_theme_3">
      <div class="topTab_item" :class="{'topTab_item_active':index==activeIndex}" v-for="(item,index) in tab" @click="changeTab(index,item)"  :key="index">
        <p>{{item.name}}</p>
        <span class="line"></span>
      </div>
    </div>
    <div v-if="$store.state.common.theme!=3" class="topTab">
      <div class="topTab_item" :class="{'topTab_item_active':index==activeIndex}" v-for="(item,index) in tab" @click="changeTab(index,item)"  :key="index">
        <p>{{item.name}}</p>
        <span class="line"></span>
      </div>
    </div>
      <div class="bottomTab_t">
      </div>
    <div class="dataList">
      <Scroll
        :data="visitorList"
        :allLoaded="allLoaded"
        @pulldown="loadData"
        @loadUp="loadup"
        v-if="visitorList.length"
      >
      <div class="dataItem" v-for="(item,index) in visitorList" :key="index" @click="details(item.id)">
         <div class="dataItem_line">
           <span class="line_title" style="color:#333333">报修类型：</span><span class="line_text">{{item.repairType}}</span>
         </div>
         <div class="dataItem_line">
           <span class="line_title">报修地点：</span><span class="line_text line_address">{{item.address}}</span>
         </div>
         <div class="dataItem_line">
           <span class="line_title">报修时间：</span><span class="line_text">{{item.createdAt}}</span>
         </div>
         <!-- <div class="dataItem_line">
           <span class="line_title">拜访地址</span><span class="line_text">{{item.visitorFloor}}</span>
         </div> -->
         <div class="dataItem_status" :class="{'status_active1':item.repairStatus!=4&&item.repairStatus!=5,'status_active4':item.repairStatus=='4','status_active5':item.repairStatus=='5'}">{{item.repairStatus|statusFilters}}</div>
      </div>
    </Scroll>
    <nomessage v-if="!visitorList.length"></nomessage>
    </div>
    <div class="bottomBtn_wrap_h">
    </div>
    <div v-if="$store.state.common.theme==3" class="bottomBtn_wrap_theme_3">
      <div class="bottomBtn" @click="add">
        新建报修
      </div>
    </div>
    <div v-if="$store.state.common.theme!=3" class="bottomBtn_wrap">
      <div class="bottomBtn" @click="add">
        新建报修
      </div>
    </div>
  </div>
</template>

<script>
import nomessage from '../../components/nomessage';
import { callSpaceUp } from '../../utils/api'
import Scroll from "../../components/scroll";
import util from "../../utils/util";
import { mapState } from 'vuex';
export default {
  name:"myRepairOrder",
  data () {
    return {
      activeIndex:0,
      tab:[
        { name:'全部',code:''},
        { name: '待处理', code: '1' },
        { name: '已派单', code: '2' },
        { name: '处理中', code: '3' },
        { name: '已完成', code: '4' }
      ],
      pageNo:1,
      pageSize: 10,
      allLoaded: false, // 可以进行上拉
      loaded: false,
      visitorList:[],
      repairStatus:""
    };
  },
  components: {
    Scroll,
    nomessage
  },
  watch: {
    $route (to, from) {
      console.log("from.name")
      console.log(from.name)
      if (from.name === 'visitDetails') {
        this.pageNo = 1;
        this.fetchData();
      }
    }
  },
  computed: {
    ...mapState({
      // openId: state => state.common.openId,
      userId: state => state.common.userId,
      common: state => state.common,
      marketInfo: state => state.common.marketInfo
    })
  },
  filters:{
    statusFilters(status){
      switch (status) {
         case '1':
           return '待处理';
         case '2':
           return '已派单';
         case '3':
           return '处理中';
         case '4':
           return '已完成';
         case '5':
           return '已关闭';
       }
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    add(item){
      this.$router.push(`/wuyeRepair`);
    },
    // 上拉加载
    loadup() {
      if (this.allLoaded) {
        return;
      }
      this.pageNo++;
      this.fetchData();
    },
    // 下拉刷新
    loadData() {
      this.pageNo = 1;
      util.showLoading()
      this.fetchData();
    },

    fetchData(){
      let postInfo = {
        lesseeIds: '',//arr.join(','), //	true	普通参数	string		租户id 多选逗号隔开
        repairTypeIds: '',//repairType.join(','), //	true	普通参数	string		报修类型 多选逗号隔开
        repairStatus:this.repairStatus,//repairStatus.join(','), //	true	普通参数	string		报修状态 多选逗号隔开
        billStatus:'',//billStatus.join(','),
        ascs:'',//ascs, //	true	普通参数	string		递增排序
        descs:'',//descs, //	true	普通参数	string		递减排序
        page: this.pageNo,
        pageSize: 10,
        thirdId: this.userId,
        platform : "RST",
        companyId: this.common.userTenantInfo.marketId,
        subProjectId:Number(this.common.marketInfo.id),
        url: "/property/rstRepair/queryRepairPage"
      }
      console.log('postInfo')
      console.log(postInfo)
      callSpaceUp(postInfo).then(res => {
        console.log('工单列表')
         console.log(res)
         util.hideLoading();
         let data = res.body.data.list;
         if (data.length !== 10) {
           this.allLoaded = true; // 若数据已全部获取完毕
         }
         if (this.pageNo === 1) {
           this.visitorList = data;
         } else {
           this.visitorList = [...this.visitorList, ...data];
         }
      })
    },
    details(id){
      this.$router.push(`/repairOrderDetails?id=${id}`);
    },
    changeTab(index,item){
      this.activeIndex = index
      this.repairStatus = item.code
      this.pageNo = 1;
      this.fetchData()
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.comReport {
  height: 100vh;
  display: flex;
  flex-direction: column;
  .nomessage{
    width: 100vh;
    height: 100vh;
  }
  .bottomTab{
    width: 100%;
    height: 108px;
    flex-shrink:1;
    position: fixed;
    left: 0;
    bottom: 0;
    .btn{
      width: 694px;
      height: 76px;
      background:rgba(23,64,218,1);
      border-radius:4px;
      font-size:32px;
      color:rgba(255,255,255,1);
      line-height:76px;
      text-align: center;
      margin: 16px 28px;
    }
  }
  .bottomTab_t{
    width:100%;
    height: 88px;
    opacity: 0;
    flex-shrink:1;
  }
  .topTab{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 88px;
    width: 100%;
    background:rgba(238,238,238,1);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
    .topTab_item{
      flex:1;
      font-size:28px;
      color:rgba(153,153,153,1);
      line-height:82px;
      text-align: center;
      .flex();
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .topTab_item_active{
      color: rgba(51, 51, 51, 1);
      .line{
        background:rgba(23,64,218,1);
      }
    }
    .line{
      display: block;
      width:32px;
      height:6px;
      background:#eee;
    }
  }
  .topTab_theme_3{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 88px;
    width: 100%;
    background:rgba(238,238,238,1);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
    .topTab_item{
      flex:1;
      font-size:28px;
      color:rgba(153,153,153,1);
      line-height:82px;
      text-align: center;
      .flex();
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .topTab_item_active{
      color: #EF9E04;
      .line{
        background: #EF9E04;

      }
    }
    .line{
      display: block;
      width:32px;
      height:6px;
      background:#eee;
    }
  }

  .dataList{
    // height: 100vh;
    flex:1;
    height:5rem;
    // margin-top: 108px;
    // .flex();
    // flex-direction: column;
    background:rgba(238,238,238,1);
    .dataItem{
      height:186px;
      background:rgba(255,255,255,1);
      border-radius:8px;
      margin:20px 20px 0;
      padding:28px;
      box-sizing: border-box;
      position: relative;
      .dataItem_status{
        font-size:24px;
        line-height:32px;
        position: absolute;
        top: 28px;
        right: 28px;
        color:rgba(153, 153, 153,1);
      }
      .status_active3{
        color:#16BC84;
      }
      .status_active1{
        color:#FD9838;
      }
      .status_active4{
        color:#16BC84;
      }
      .status_active5{
        color: #999999;
      }
      .dataItem_line{
        height: 34px;
        margin-bottom:8px;
        .line_title,.line_text{
          font-size:24px;
          color:rgba(153,153,153,1);
          line-height:34px;
          display: inline-block;
          margin-right: 28px;
        }
        .line_text{
          color:rgba(51,51,51,1);
        }
        .line_address{
          width: 410px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
  .main_scroll{
    flex:1;
  }
  .bottomBtn_wrap_h{
    width:100%;
    height:108px;
  }
  .bottomBtn_wrap{
    height:108px;
    background:rgba(255,255,255,1);
    position: fixed;
    left: 0;right:0;
    padding:0 28px;
    box-sizing: border-box;
    bottom: 0;
    .bottomBtn{
      width:100%;
      height:76px;
      background:rgba(23,64,218,1);
      border-radius:4px;
      text-align: center;
      line-height: 76px;
      font-size:32px;
      color:rgba(255,255,255,1);
      margin: 16px 0;
    }
  }

  .bottomBtn_wrap_theme_3{
    height:108px;
    background:rgba(255,255,255,1);
    position: fixed;
    left: 0;right:0;
    padding:0 28px;
    box-sizing: border-box;
    bottom: 0;
    .bottomBtn{
      width:100%;
      height:76px;
      background: #A1805D;

      border-radius:19px;
      text-align: center;
      line-height: 76px;
      font-size:32px;
      color:rgba(255,255,255,1);
      margin: 16px 0;
    }
  }
}

</style>
